import type { PortableTextTypeComponentProps } from '@portabletext/react'
import clsx from 'clsx'
import { useMemo, type FC } from 'react'

import { LinkButton } from '@/components/Link/LinkButton'
import type { CMSBaseLinkButton } from '@/types/sanity'
import './button-group.scss'

// TODO: improve type defintion here
export const ButtonGroup: FC<
  PortableTextTypeComponentProps<{
    group: CMSBaseLinkButton[]
    horizontalAlignment: string
  }>
> = ({ value }) => {
  const buttonGroupClass = useMemo(
    () => [
      'section-rich-text-button-group',
      value.group.length === 1 && 'section-rich-text-button-group--single',
      {
        'section-rich-text-button-group--left':
          value.horizontalAlignment === 'left',
      },
    ],
    [],
  )

  return (
    <div className={clsx(buttonGroupClass)}>
      {value.group.map((item, index) => (
        <LinkButton link={item} key={index} />
      ))}
    </div>
  )
}
